/**
 * Hyperform
 *
 * Hyperform is a pure JS implementation of the HTML 5 form validation API.
 * @docs https://hyperform.js.org/docs
 */
import hyperform from 'hyperform';

export default () => {
  const forms = document.querySelectorAll('form');
  if (!forms.length) {
    return;
  }

  forms.forEach((form) => {
    // Custom validation messages
    form.querySelectorAll('input[type="email"]').forEach((el) => {
      hyperform.setMessage(el, 'typeMismatch', 'Please enter a valid email address.');
    });

    form.querySelectorAll('select').forEach((el) => {
      hyperform.setMessage(el, 'valueMissing', 'Please select an option.');
    });

    // Intercept submit buttons using inline onclick
    const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

    submitButton?.addEventListener(
      'click',
      (e) => {
        if (!form.checkValidity()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          form.reportValidity();
        }
      },
      // capture phase is key to override inline onclick, or anything else that triggers the click event on the button artificially
      true
    );
  });

  // Initialize Hyperform
  hyperform(window, {
    classes: {
      warning: 'error-message',
      validated: '-validated',
      valid: '-valid',
      invalid: '-invalid'
    }
  });
};
